import React from 'react';
import NutritionInformationSection from '../NutritionInformationSection';
import { NonPrepackagedProps } from '../types';

const NonPrepackaged: React.FC<NonPrepackagedProps> = (props) => {
  return <NutritionInformationSection data-testid="nutritions-form-non-prepacked" {...props} />;
};

export default NonPrepackaged;
